import {useEffect, useRef, useState} from 'react'
import earlyAccessBanner from '../../../../media/EarlyAccess/recordskeeper-ai-early-access-landing-page-banner.png'
import earlyAccessBannerDark from '../../../../media/EarlyAccess/recordskeeper-ai-early-access-landing-page-banner-dark.png'
// import EarlyAccessForm from '../components/EarlyAccessForm'
// import EarlyAccessSuccess from '../components/EarlyAccessInviteSuccess'
import {EarlyInviteCard} from '../components/EarlyInviteCard'
// import {EarlyInvitees} from '../components/EarlyInvitees'
import {EarlyLandingPage} from '../components/EarlyLandingPage'
import {toast} from 'react-toastify'
import {useAuth} from '../../auth'
import {useIntl} from 'react-intl'
import {companyData} from '../../profile/core/_requests'
import {getEarlyOfferStatus, getInvitees} from '../core/_requests'
import {useThemeMode} from '../../../../_metronic/partials'
import {EarlyInvitees} from '../components/EarlyInvitees'
import TagManager from 'react-gtm-module'
import {GTMEvent, loginSuccessMeta} from '../../../hooks/gtmHelpers'
import {removeNullFields} from '../../../core/_util'

export const EarlyAccessInvite = () => {
  const {currentUser, companyId, selected, currencyBill, currentState} = useAuth()
  const {formatMessage} = useIntl()
  const {mode} = useThemeMode()
  const [totalWaitingList, setTotalWaitingList] = useState<number>(0)
  const [isOfferClaimed, setIsOfferClaimed] = useState(false)
  const [queuePosition, setQueuePosition] = useState<number>()
  const [isQueueLoading, setIsQueueLoading] = useState(false) // eslint-disable-line
  const [invitees, setInvitees] = useState<any[]>([])
  const mounted = useRef(false)

  useEffect(() => {
    // Check if the component has mounted
    if (!mounted.current) {
      setTimeout(() => {
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.DashboardViewSuccessful,
            metadata: removeNullFields({
              ...loginSuccessMeta(currentUser, `${selected}-${currencyBill}-${currentState}`),
            }),
          },
        })
      }, 400)

      mounted.current = true
    }
  }, [companyId]) // eslint-disable-line react-hooks/exhaustive-deps

  const getOfferStatus = async () => {
    try {
      const {
        data: {success, data},
      } = await getEarlyOfferStatus(companyId!)
      if (success) {
        setIsOfferClaimed(data.isOfferClaimed)
      }
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    if (companyId) {
      getOfferStatus()
    }
  }, [companyId]) // eslint-disable-line

  const getCompanyData = async () => {
    setIsQueueLoading(true)
    try {
      if (companyId) {
        const {
          data: {success, data, errors},
        } = await companyData(companyId)
        if (success) {
          setTotalWaitingList(data.totalQueueCount)
          setQueuePosition(data.queuePosition)
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setIsQueueLoading(false)
    }
  }

  useEffect(() => {
    if (companyId) {
      getCompanyData()
      getConfirmedInvitees()
    }
  }, [companyId]) // eslint-disable-line react-hooks/exhaustive-deps

  const getConfirmedInvitees = async () => {
    try {
      if (companyId) {
        const {
          data: {success, data},
        } = await getInvitees(companyId)
        if (success) {
          setInvitees(data)
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
    }
  }

  return (
    <>
      <div className='px-6 mb-8'>
        <div className='row'>
          <div className='col-md-9 bg-white rounded-2 p-6'>
            {/* Header */}
            <div className='shadow-md'>
              {mode === 'dark' ? (
                <img
                  src={earlyAccessBannerDark}
                  alt='RecordsKeeper AI Early Access'
                  className='w-100'
                />
              ) : (
                <img
                  src={earlyAccessBanner}
                  alt='RecordsKeeper AI Early Access'
                  className='w-100'
                />
              )}
            </div>

            <EarlyLandingPage
              totalWaitingList={totalWaitingList}
              isOfferClaimed={isOfferClaimed}
              queuePosition={queuePosition!}
              isQueueLoading={isQueueLoading}
            />
          </div>

          <div className='col-md-3 mt-4 mt-md-0 px-0 px-md-3'>
            <EarlyInviteCard />
            <EarlyInvitees invitees={invitees} />
          </div>
        </div>
      </div>
    </>
  )
}
